import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import StepToShowComponent from "../../components/Step";
import { DomesticProvider } from "./DomesticContext";
import { SpaceBox } from "../../components/Space";
import PaymentErrorModalComponent from "../../components/PaymentErrorModal";
import { STEPS } from "../../data/domestic";
import OrderService from "../../service/order";
import DomesticStep1 from "./Step1";
import DomesticStep2 from "./Step2";
import DomesticStep3 from "./Step3";
import DomesticStep4 from "./Step4";
import DomesticStep5 from "./Step5";
import DomesticStep6 from "./Step6";
import DomesticStep7 from "./Step7";
import { CookieUtils, Alert, IdentityUtils } from "../../utils";
import moment from "moment";
import DecoratedGraphic from "../../images/graphic.png";
import crypter from "../../utils/crypter";
import { TYPE_CODES } from "../../const";
import CalculateService from "../../service/calulate";
import ConsentPage from "./consent";

class DomesticPage extends Component {
  state = {
    showErroModal: false,
    errorTitle: "การชำระเงินไม่สำเร็จ",
    errorMessage: "คุณไม่สามารถดำเนินการชำระเงินได้ กรุณาชำระอีกครั้ง",
    steps: STEPS,
    page: 0,

    step1: {
      type: null,
      deliveryBy: "",
      deliveryByOther: "",
      start_date: "",
      end_date: "",
      counter: 1,
      purposeTour: "",
      langague: null,
      onChangeModel: (object, cb) => this.changeModelStep1(object, cb),
      onChangeDate: (object) => this.changeDate(object),
    },
    step2: {
      planList: [],
      defaultKey: "",
      selectedPlan: "",
      acceptInsurance: false,
      acceptHealthCheck: false,
      onChangeModel: (object) => this.changeModelStep2(object),
    },
    step3: {
      insures: [
        {
          sNationality: { value: "THA", label: "Thailand" },
          sNo: "",
          sMoo: "",
          sSoi: "",
          sRoad: "",
          sProvince: "",
          sDistrict: "",
          sCity: "",
          sZipcode: "",
          sBuilding: "",
          benefits: [{ sInit: "", sFirstName: "", sLastName: "", sRelation: "" }],
        },
      ],
      onChangeModel: (object) => this.changeModelStep3Insurance(object),
      onChangeNationality: (object) => this.changeModelStep3Nationality(object),
      onChangeAddressOther: (object) => this.changeModelStep3AddressOther(object),
      onChangeBenefit: (object) => this.changeModelStep3Benefit(object),
      onAddBenefit: (key) => this.onHandleBenefit(key, "Add"),
      onRemoveBenefit: (key) => this.onHandleBenefit(key, "Remove"),
      onChangeModelProvinces: (object) => this.changeModelProvinces(object),
    },
    step4: {
      recieveEmail: true,
      recievePost: "",
      editKey: 0,
      confirmInsurance: "",
      onChangeModel: (object) => this.changeModelStep4Insurance(object),
      onEditUser: (object) => this.changeEditUser(object),
    },
    step5: {
      paymentModel: {},
    },
    step7: {
      cName: "",
      cLastName: "",
      cMobile: "",
      cEmail: "",
      cReason: "",
      cDetail: "",
      cDate: "",
      cTime: "",
      onChangeModel: (object) => this.changeModelStep7(object),
      onNavigate: (object) => this.onNavigate(object),
    },
  };

  constructor(props) {
    super(props);
    this.initPage();
  }

  initPage() {
    let stateBack = localStorage.getItem("states_dom");
    let paymentResponse = CookieUtils.getCookie("pay_result_dom");
    if (paymentResponse && stateBack) {
      //decode
      if (window && window.decodeURIComponent) {
        paymentResponse = window.decodeURIComponent(paymentResponse);
        stateBack = window.decodeURIComponent(stateBack);
      }
      paymentResponse = crypter.decode(paymentResponse);
      stateBack = crypter.decode(stateBack);
      //Case Error
      const { payment_result } = paymentResponse;
      const isSuccess = payment_result.success;
      this.state.page = isSuccess ? 6 : 5;
      let { step1, step2, step3, step4, step5 } = this.state;
      step1 = { ...step1, ...stateBack.step1 };
      step2 = { ...step2, ...stateBack.step2 };
      step3 = { ...step3, ...stateBack.step3 };
      step4 = { ...step4, ...stateBack.step4 };
      step5 = { ...step5, ...stateBack.step5 };

      this.state = {
        ...this.state,
        step1,
        step2,
        step3,
        step4,
        step5,
        step6: {
          ...paymentResponse,
        },
      };

      if (!isSuccess) {
        this.state.showErroModal = true;
      }

      localStorage.setItem("states_dom", "");
      CookieUtils.setCookie("pay_result_dom", "");
    }
  }

  onHandleBenefit(key, type) {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    if (type === "Add") {
      insures[key].benefits.push({
        sInit: "",
        sFirstName: "",
        sLastName: "",
        sRelation: "",
      });
      step3.insures = insures;
      this.setState({ ...this.state, step3 });
    } else if (type === "Remove") {
      const benefit = insures[key].benefits[0];
      insures[key].benefits = [benefit];
      step3.insures = insures;
      this.setState({ ...this.state, step3 });
    }
  }

  onNavigate = (page) => {
    const { step1, step2, step3 } = this.state;
    if (page === 0) {
      // this.props.history.replace("/");
    } else if (page === 2) {
      step3.insures = [];

      for (let i = 1; i <= step1.counter; i++) {
        const field = {
          sNationality: { value: "THA", label: "Thailand" },
          sNo: "",
          sMoo: "",
          sSoi: "",
          sRoad: "",
          sProvince: "",
          sDistrict: "",
          sCity: "",
          sZipcode: "",
          benefits: [{ sInitNameTH: "", sFirstName: "", sLastName: "", sRelation: "" }],
        };
        step3.insures.push(field);
      }
      const { purposeTour } = step1;
      if (purposeTour.isRisk) {
        const handleClickClose = () => {
          this.setState({ ...this.state, page: 1 }, () => window.scrollTo(0, 0));

          Alert.hideLoading();
        };

        Alert.alertMessage(
          "กรุณาติดต่อเจ้าหน้าที่",
          "วัตถุประสงค์ของการท่องเที่ยวที่ระบุ เป็นการท่องเที่ยวที่ประกันภัยไม่คุ้มครอง",
          "warning",
          "true",
          "ติดต่อเจ้าหน้าที่",
          "true",
          "ยกเลิก"
        ).then((res) => {
          if (res === "option1") {
            this.setState({ ...this.state, page: 7 }, () => window.scrollTo(0, 0));
          }
        });
        return true;
      }
    } else if (page === 4) {
      const { langague } = step1
      const { selectedPlan } = step2;
      const { insures } = step3 || {};
      for (let i = 0; i < step1.counter; i++) {
        const { sNationality, sBirthDate } = insures[i];
        const age = sBirthDate ? moment.utc().diff(moment(sBirthDate), "years") : 0;
        if (age < 16 && selectedPlan > 2) {
          let warningText = langague === 2 
          ? "Attention: In the 1-to-15 age group, the maximum sum insured is 500,000 baht."
          : "ขออภัยค่ะ สำหรับอายุ 1 - 15 ปีสามารถทำทุนประกันภัยได้สูงสุดไม่เกิน 500,000 บาท";
          Alert.alertWithTitle(
            "กรุณาทำรายการใหม่อีกครั้ง",
            warningText,
            "warning"
          );
          return false;
        }
        if (sNationality && sNationality.value === "THA") {
          if (!this._validForm(step3.insures[i].sIDNo)) {
            return false;
          }
        }
      }
      if (!this._validEmail()) {
        return false;
      }
    } else if (page === 5) {
      this._onVerifyOrder();
      return;
    }
    this.setState({ ...this.state, page }, () => window.scrollTo(0, 0));
  };

  //UI Action Step1
  changeModelStep1 = ({ name, value }, cb = () => {}) => {
    const { step1 } = this.state;
    step1[name] = value;
    this.setState({ ...this.state, step1 }, cb);
  };
  changeDate = ({ name, value }) => {
    const { step1 } = this.state;
    step1[name] = value;
    this.setState({ ...this.state, step1 }, () => this.fetchPlan());
  };

  async fetchPlan(cb) {
    const { step1 } = this.state;
    const diffDate = this.getDiffDate();
    if (diffDate && typeof diffDate === "number") {
      try {
        let plans = await this.callFetchPlans(diffDate, step1.counter);
        plans = plans.map((plan, i) => {
          return {
            ...plan,
            title: `ทุนประกัน (แผนที่ ${i + 1})`,
          };
        });
        console.log("plan change");
        this.changePlanStep1(plans, cb);
        Alert.hideLoading();
      } catch {
        Alert.hideLoading();
      }
    }
  }

  async callFetchPlans(diffDate, counter) {
    try {
      Alert.showLoading();
      const data = await CalculateService.rate({
        type_code: TYPE_CODES.TA,
        day: diffDate,
        counter,
      });
      if (data && data.length === 0) {
        this.callFetchPlans(diffDate, counter);
      }
      return data;
    } catch {
      return [];
    }
  }

  changePlanStep1 = (planList, cb) => {
    const { step2 } = this.state;
    step2.planList = planList;
    step2.selectedPlan = "";
    this.setState({ ...this.state, step2 }, cb);
  };

  changeModelStep2 = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelStep3Insurance = ({ key, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key][name] = value;
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };
  changeModelStep3Nationality = ({ key, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key][name] = value;
    insures[key]["sIDNo"] = "";
    insures[key]["sPassportNo"] = "";
    insures[key]["sExpiryDate"] = "";
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };
  changeModelProvinces = ({ key, addressChange }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    const step3Change = {
      ...insures[key],
      ...addressChange,
    };
    step3.insures[key] = step3Change;
    this.setState({ ...this.state, step3 });
  };
  changeModelStep3AddressOther = ({ key }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key] = {
      ...insures[key],
      sNo: "",
      sMoo: "",
      sSoi: "",
      sRoad: "",
      sProvince: "",
      sDistrict: "",
      sCity: "",
      sZipcode: "",
    };
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };
  changeModelStep3Benefit = ({ key, index, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key].benefits[index][name] = value;
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep4Insurance = ({ name, value }) => {
    const { step4 } = this.state;
    step4[name] = value;
    this.setState({ ...this.state, step4 });
  };

  changeModelStep7 = ({ name, value }) => {
    const { step7 } = this.state;
    step7[name] = value;
    this.setState({ ...this.state, step7 });
  };

  changeEditUser = ({ name, value }) => {
    const { step4 } = this.state;
    step4[name] = value;
    this.setState({ ...this.state, step4 });
    this.setState({ ...this.state, page: 3 }, () => window.scrollTo(0, 0));
  };

  checkDisbledNextButton() {
    const { page } = this.state;
    if (page == 1) {
      const { step1 } = this.state;
      const {
        type,
        langague,
        start_date,
        end_date,
        deliveryBy,
        deliveryByOther,
        purposeTour,
        provinceFrom,
        provinceTo,
      } = step1 || {};
      if (
        !type ||
        !langague ||
        !start_date ||
        !end_date ||
        !deliveryBy ||
        !purposeTour ||
        !provinceFrom ||
        !provinceTo
      ) {
        return true;
      } else if (deliveryBy && deliveryBy.value === "อื่นๆ" && !deliveryByOther) {
        return true;
      }
      return false;
    } else if (page === 2) {
      const { step2 } = this.state;

      const { selectedPlan, acceptInsurance, acceptHealthCheck } = step2 || {};
      if (!selectedPlan || !acceptInsurance || !acceptHealthCheck) {
        return true;
      } else {
        return false;
      }
    } else if (page === 3) {
      const { step1, step3 } = this.state;
      const { insures } = step3 || {};
      const { counter } = step1;
      for (let i = 0; i < counter; i++) {
        const {
          sNationality,
          sIDNo,
          sPassportNo,
          sExpiryDate,
          sSex,
          sInitNameTH,
          sFirstNameTH,
          sLastNameTH,
          sInitNameEN,
          sFirstNameEN,
          sLastNameEN,
          sBirthDate,
          sMobile,
          sNo,
          sProvince,
          sDistrict,
          sCity,
          sZipcode,
          benefits,
          isSameIdentity,
        } = insures[i];
        if (i > 0) {
          if (!isSameIdentity) {
            return true;
          }
          if (isSameIdentity === 2) {
            if (!sNo || !sProvince || !sDistrict || !sCity || !sZipcode) {
              return true;
            }
          }
        }
        if (
          !sNationality ||
          !sSex ||
          !sInitNameTH ||
          !sFirstNameTH ||
          !sLastNameTH ||
          !sInitNameEN ||
          !sFirstNameEN ||
          !sLastNameEN ||
          !sBirthDate ||
          !sMobile
        ) {
          return true;
        }
        if (sNationality && sNationality.value === "THA") {
          if (!sIDNo) {
            return true;
          }
        }
        if (sNationality && sNationality.value !== "THA") {
          if (!sPassportNo || !sExpiryDate) {
            return true;
          }
        }
        for (let i = 0; i < benefits.length; i++) {
          if (!benefits[i].sInit || !benefits[i].sFirstName || !benefits[i].sLastName || !benefits[i].sRelation) {
            return true;
          }
        }
      }
    } else if (page === 4) {
      const { step4 } = this.state;
      const { recieveEmail, recievePost, confirmInsurance } = step4;

      if (!confirmInsurance) {
        return true;
      }
      if (!recieveEmail && !recievePost) {
        return true;
      } else {
        return false;
      }
    }
  }

  _validForm(idCard) {
    let check = true;
    if (!IdentityUtils.validateIdentity(idCard)) {
      check = false;
    }
    return check;
    // const { step3 } = this.state;
    // let check = true;
    // step3.insures.map((i, index) => {
    //   if (!IdentityUtils.validateIdentity(i.sIDNo)) {
    //     check = false;
    //   }
    // });
    // return check;
  }

  _validEmail() {
    const { step3 } = this.state;
    let check = true;
    step3.insures.map((i, index) => {
      if (!IdentityUtils.validateEmail(i.sEmail)) {
        check = false;
      }
    });
    return check;
  }

  _onVerifyOrder() {
    const { step1, step2, step3, step4 } = this.state;
    const { recieveEmail = false, recievePost = false } = step4;
    const { insures } = step3;
    const planDetail = step2.planList.filter((plan) => plan.id === step2.selectedPlan)[0];
    const personalAssurances = step3.insures.map((i, index) => {
      let benefit = {};
      i.benefits.map((be, index) => {
        const seq = index + 1;
        benefit[`objBeneficiary${seq}`] = {
          sBeneficiarySeq: seq,
          sInit: be.sInit.label,
          sFirstName: be.sFirstName,
          sLastName: be.sLastName,
          sRelationID: be.sRelation.value,
          sRelation: be.sRelation.label,
        };
      });

      return {
        sApplicantSeq: index + 1,
        sType: "A",
        sPersonType: "P",
        sInitNameTH: i.sNationality.value === "THA" ? i.sInitNameTH.label : i.sInitNameEN.label,
        sFirstNameTH: i.sNationality.value === "THA" ? i.sFirstNameTH : i.sFirstNameEN,
        sLastNameTH: i.sNationality.value === "THA" ? i.sLastNameTH : i.sLastNameEN,

        sInitNameEN: i.sInitNameEN.label,
        sFirstNameEN: i.sFirstNameEN,
        sLastNameEN: i.sLastNameEN,

        sIDNo:
          i.sNationality.value === "THA" && i.sIDNo ? i.sIDNo.replace(/-/g, "") : i.sPassportNo ? i.sPassportNo : "",
        sIDType: i.sNationality.value === "THA" ? "ID card" : "Passport",
        sSex: i.sSex,

        // sOccupationID: i.sOccupation.value,
        // sOccupation: i.sOccupation.label,
        sMobile: i.sMobile,
        sEmail: i.sEmail,

        sRDConsent: "",
        sNationality: i.sNationality.value,
        sBirthDate: moment(i.sBirthDate).format("YYYY/MM/DD"),
        objApplicantAddress: {
          sType: "A",
          sBuilding: i.sBuilding ? i.sBuilding : !i.sBuilding && i.isSameIdentity === 1 ? insures[0].sBuilding : "",
          sVillage: i.sBuilding ? i.sBuilding : !i.sBuilding && i.isSameIdentity === 1 ? insures[0].sBuilding : "",
          sNo: i.sNo ? i.sNo : !i.sNo && i.isSameIdentity === 1 ? insures[0].sNo : "",
          sMoo: i.sMoo ? i.sMoo : !i.sMoo && i.isSameIdentity === 1 ? insures[0].sMoo : "",
          sSoi: i.sSoi ? i.sSoi : !i.sSoi && i.isSameIdentity === 1 ? insures[0].sSoi : "",
          sRoad: i.sRoad ? i.sRoad : !i.sRoad && i.isSameIdentity === 1 ? insures[0].sRoad : "",
          sProvince: i.sProvince.label
            ? i.sProvince.label
            : !i.sProvince.label && i.isSameIdentity === 1
            ? insures[0].sProvince.label
            : "",
          sCity: i.sDistrict.label
            ? i.sDistrict.label
            : !i.sDistrict.label && i.isSameIdentity === 1
            ? insures[0].sDistrict.label
            : "",
          sDistrict: i.sCity.label ? i.sCity.label : !i.sCity.label && i.isSameIdentity === 1 ? insures[0].sCity.label : "",
          sZipcode: i.sZipcode ? i.sZipcode : !i.sZipcode && i.isSameIdentity === 1 ? insures[0].sZipcode : "",
        },
        ...benefit,
      };
    });

    const { sEmail, sMobile } = step3.insures[0];
    const { counter, provinceTo, provinceFrom, provinceOther, type } = step1;
    const from = provinceFrom ? provinceFrom.label + "-" : "";
    const otherConcat = (provinceOther || []).map((po) => po.label).join("-");
    const to = provinceTo ? "-" + provinceTo.label : "";
    let provinceTravel = from + otherConcat + to
    if (type === 4) {
      const fromNoDash = provinceFrom ? provinceFrom.label : "";
      provinceTravel += `-${fromNoDash}`;
    }
    const objRequest = {
      objMaster: {
        sProductCode: "MTI06119",
        sPackageCode: planDetail.packageCode,
        planName: planDetail.product_name + ` (แผนที่ ${planDetail.plan_package})`,
        sPackagePremium: planDetail.price,
        sTotalPremium: planDetail.total,
        sStamp: planDetail.stamp,
        sVat: planDetail.vat,
        sBKOrderNo: CookieUtils.getCookie("app_bk_no"), //uId ,
        sFromDate: moment(step1.start_date).format("YYYY/MM/DD"),
        sToDate: moment(step1.end_date).format("YYYY/MM/DD"),
        sCountriesEN: provinceTravel,
        sSendDocBy: sEmail,
        sContactMT: sMobile,
        sDeliveryTo: recieveEmail && recievePost ? "Both" : recieveEmail ? "Email" : "POST",
        lstObjOptional: [],
        // lstObjOptional: [{
        //   sOptionalCode: 'TRV',//planDetail.packageCode,
        //   sOptionalDesc: planDetail.name,
        //   sOptionalPremium: planDetail.total
        // }]
      },
      lstObjApplicantPerson: personalAssurances,
      objStep: {
        step1,
        step2,
        step3,
        step4,
      },
    };

    Alert.showLoading();
    OrderService.orderVerify(objRequest)
      .then((res) => {
        Alert.hideLoading();
        if (res.info.bSuccess && res.hash) {
          const { step5 } = this.state;
          step5.paymentModel = res.hash;
          this.setState({ ...this.state, page: 5, step5 }, () => window.scrollTo(0, 0));
        } else if (!res.info.bSuccess) {
          console.log("Not completed:", res.info.lstObjResultKey[0].resultDesc.sDescTH);
          if (res.info.lstObjResultKey[0].resultDesc.sMTICode.includes("E")) {
            Alert.alertMessage(
              "กรุณากรอกข้อมูลให้ถูกต้อง",
              "ขออภัยค่ะ คุณสมบัติของท่านไม่เป็นไปตามเงื่อนไขการรับประกันภัย กรุณาติดต่อเจ้าหน้าที่ที่เบอร์ 1484 หรือฝากข้อมูลให้เจ้าหน้าที่ติดต่อกลับ",
              "warning",
              "true",
              "ติดต่อเจ้าหน้าที่",
              "true",
              "ยกเลิก",
            )
            .then(res => {
              if (res === "option1") {
                this.onNavigate(7);
              }
            });
          } else {
            Alert.alertWithTitle("กรุณาทำรายการใหม่อีกครั้ง", res.info.lstObjResultKey[0].resultDesc.sDescTH, "warning");
          }
        }
      })
      .catch((err) => {
        Alert.hideLoading();
      });
  }

  getDiffDate() {
    const { start_date, end_date } = this.state.step1;

    return start_date && end_date ? moment(end_date).diff(moment(start_date), "days") + 1 : "-";
  }

  render() {
    const { showErroModal, errorTitle, errorMessage, page, steps, step1, step2, step3, step4, step5, step6, step7 } =
      this.state;
    const isDisabledNext = this.checkDisbledNextButton();
    // const pageIndex = page === 3 || page === 4 ? 3: page;
    const diffDate = this.getDiffDate();

    return (
      <Fragment>
        {page > 0 && page < 5 && <StepToShowComponent steps={steps} currentPage={page} />}
        {page === 0 && <ConsentPage />}
        {page === 1 && (
          <DomesticProvider value={{ step1, diffDate }}>
            <DomesticStep1 />
          </DomesticProvider>
        )}
        {page === 2 && (
          <DomesticProvider value={{ step2, diffDate, counter: step1.counter }}>
            <DomesticStep2 />
          </DomesticProvider>
        )}
        {page === 3 && (
          <DomesticProvider value={{ step1, step3, step4 }}>
            <DomesticStep3 />
          </DomesticProvider>
        )}
        {page === 4 && (
          <DomesticProvider value={{ step1, step2, step3, step4, diffDate }}>
            <DomesticStep4 />
          </DomesticProvider>
        )}
        {page === 5 && (
          <DomesticProvider value={{ step1, step2, step3, step4, step5, diffDate }}>
            <DomesticStep5 />
            <div className="graphic flex-1">
              <img src={DecoratedGraphic} className="graphic-img" alt="span image" />
              {/* <div className="form-wrapper footer">
                <a
                  href=""
                  className="pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    this.onNavigate(page - 1);
                    return;
                  }}
                >
                  ย้อนกลับ
                </a>
              </div> */}
            </div>
          </DomesticProvider>
        )}
        {page === 6 && (
          <DomesticProvider value={{ step1, step2, step5, step6 }}>
            <DomesticStep6 />
          </DomesticProvider>
        )}
        {page === 7 && (
          <DomesticProvider value={{ step7 }}>
            <DomesticStep7 />
          </DomesticProvider>
        )}
        {page === 0 && (
          <>
            <button
              className="form-control btn-primary floating-buy"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ซื้อประกัน
            </button>
          </>
        )}
        {page > 0 && page < 5 && (
          <div className="form-wrapper d-flex mt-0 mb-5">
            <button className="form-control" onClick={() => this.onNavigate(page - 1)}>
              ย้อนกลับ
            </button>
            <SpaceBox w="12px" />
            <button
              className="form-control btn-primary"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ถัดไป
            </button>
          </div>
        )}

        <PaymentErrorModalComponent
          show={showErroModal}
          title={errorTitle}
          message={errorMessage}
          hideModal={() => this.setState({ ...this.state, showErroModal: false })}
        />
      </Fragment>
    );
  }
}

export default withRouter(DomesticPage);
